import React from "react";
import BackButton from "../common/BackButton";
import CommonHeader from "./CommonHeader";
import ProfileAvatar from "./ProfileAvatar";

const ProfileWithBackButtonHeader = ({ onClick }) => {
  const handleGoBack = () => {
    if (onClick) {
      onClick(); // เรียกฟังก์ชันที่ส่งเข้ามา
    } else {
      window.history.back(); // fallback กรณีไม่มี onClick
    }
  };

  return (
    <div className="h-20 flex flex-col justify-end bg-primary">
      <CommonHeader
        left={<BackButton onClick={handleGoBack} />}
        right={<ProfileAvatar />}
        className="bg-primary"
      />
    </div>
  );
};

export default ProfileWithBackButtonHeader;
